/* Printora tiny blank-garment colour fallbacks — garment-aware sprite edition, 11 Sep 2026 */
(() => {
  'use strict';

  const VERSION = '2026-09-11b';
  const existing = window.PrintoraColourFallbacks;
  if (existing?.version === VERSION) {
    existing.syncAll?.();
    return;
  }

  const INDEX = {"at002":{"arctic-white":{"col":0,"row":0},"baby-pink":{"col":1,"row":0},"bottle-green":{"col":2,"row":0},"burgundy":{"col":3,"row":0},"cornflower-blue":{"col":4,"row":0},"deep-black":{"col":5,"row":0},"desert-sand":{"col":6,"row":0},"dusty-lilac":{"col":7,"row":0},"earthy-green":{"col":8,"row":0},"fire-red":{"col":9,"row":0},"heather-grey":{"col":10,"row":0},"hot-pink":{"col":11,"row":0},"kelly-green":{"col":0,"row":1},"mocha-brown":{"col":1,"row":1},"natural-stone":{"col":2,"row":1},"new-french-navy":{"col":3,"row":1},"orange-crush":{"col":4,"row":1},"purple":{"col":5,"row":1},"royal-blue":{"col":6,"row":1},"sapphire-blue":{"col":7,"row":1},"seafoam":{"col":8,"row":1},"sky-blue":{"col":9,"row":1},"solid-charcoal":{"col":10,"row":1},"sun-yellow":{"col":11,"row":1}},"at003":{"arctic-white":{"col":0,"row":2},"atlantic-blue":{"col":1,"row":2},"deep-black":{"col":2,"row":2},"heather-grey":{"col":3,"row":2},"moss-green":{"col":4,"row":2},"natural-stone":{"col":5,"row":2},"new-french-navy":{"col":6,"row":2}},"at01j":{"heather-grey":{"col":0,"row":0},"fire-red":{"col":1,"row":0},"deep-black":{"col":2,"row":0},"baby-pink":{"col":3,"row":0},"sapphire-blue":{"col":0,"row":1},"royal-blue":{"col":1,"row":1},"new-french-navy":{"col":2,"row":1},"kelly-green":{"col":3,"row":1}},"jh01j":{"airforce-blue":{"col":7,"row":2},"arctic-white":{"col":8,"row":2},"ash":{"col":9,"row":2},"baby-pink":{"col":10,"row":2},"black-smoke":{"col":11,"row":2},"bottle-green":{"col":0,"row":3},"bright-royal":{"col":1,"row":3},"burgundy":{"col":2,"row":3},"candyfloss-pink":{"col":3,"row":3},"charcoal":{"col":4,"row":3},"deep-black":{"col":5,"row":3},"desert-sand":{"col":6,"row":3},"digital-lavender":{"col":7,"row":3},"dusty-green":{"col":8,"row":3},"dusty-pink":{"col":9,"row":3},"fire-red":{"col":10,"row":3},"forest-green":{"col":11,"row":3},"hawaiian-blue":{"col":0,"row":4},"heather-grey":{"col":1,"row":4},"hot-pink":{"col":2,"row":4},"ice-blue":{"col":3,"row":4},"jade":{"col":4,"row":4},"jet-black":{"col":5,"row":4},"kelly-green":{"col":6,"row":4},"khaki":{"col":7,"row":4},"lilac":{"col":8,"row":4},"lime-green":{"col":9,"row":4},"natural-stone":{"col":10,"row":4},"new-french-navy":{"col":11,"row":4},"olive-green":{"col":0,"row":5},"orange-crush":{"col":1,"row":5},"oxford-navy":{"col":2,"row":5},"peppermint":{"col":3,"row":5},"platinum-grey":{"col":4,"row":5},"plum":{"col":5,"row":5},"purple":{"col":6,"row":5},"rainforest-green":{"col":7,"row":5},"red-hot-chilli":{"col":8,"row":5},"royal-blue":{"col":9,"row":5},"sapphire-blue":{"col":10,"row":5},"seafoam":{"col":11,"row":5},"sky-blue":{"col":0,"row":6},"solid-charcoal":{"col":1,"row":6},"storm-grey":{"col":2,"row":6},"sun-yellow":{"col":3,"row":6},"vanilla-milkshake":{"col":4,"row":6}},"jh30j":{"arctic-white":{"col":5,"row":6},"baby-pink":{"col":6,"row":6},"bottle-green":{"col":7,"row":6},"bright-royal":{"col":8,"row":6},"burgundy":{"col":9,"row":6},"charcoal":{"col":10,"row":6},"deep-black":{"col":11,"row":6},"desert-sand":{"col":0,"row":7},"digital-lavender":{"col":1,"row":7},"dusty-green":{"col":2,"row":7},"dusty-pink":{"col":3,"row":7},"fire-red":{"col":4,"row":7},"heather-grey":{"col":5,"row":7},"hot-pink":{"col":6,"row":7},"ice-blue":{"col":7,"row":7},"jet-black":{"col":8,"row":7},"kelly-green":{"col":9,"row":7},"lime-green":{"col":10,"row":7},"mustard":{"col":11,"row":7},"new-french-navy":{"col":0,"row":8}},"rx301":{"black":{"col":1,"row":8},"burgundy":{"col":2,"row":8},"charcoal":{"col":3,"row":8},"fuchsia":{"col":4,"row":8},"heather-grey":{"col":5,"row":8},"kelly-green":{"col":6,"row":8},"khaki":{"col":7,"row":8},"navy":{"col":8,"row":8},"orange":{"col":9,"row":8},"purple":{"col":10,"row":8},"red":{"col":11,"row":8},"royal-blue":{"col":0,"row":9},"sapphire-blue":{"col":1,"row":9},"sky-blue":{"col":2,"row":9}},"rx350":{"black":{"col":3,"row":9},"bottle-green":{"col":4,"row":9},"burgundy":{"col":5,"row":9},"charcoal":{"col":6,"row":9},"fuchsia":{"col":7,"row":9},"heather-grey":{"col":8,"row":9},"kelly-green":{"col":9,"row":9},"khaki":{"col":10,"row":9},"navy":{"col":11,"row":9},"orange":{"col":0,"row":10},"purple":{"col":1,"row":10},"red":{"col":2,"row":10},"royal-blue":{"col":3,"row":10},"sapphire-blue":{"col":4,"row":10},"sky-blue":{"col":5,"row":10},"solid-grey":{"col":6,"row":10},"stone":{"col":7,"row":10},"turquoise":{"col":8,"row":10}}};

  const SPRITES = {
    main: {
      url: 'https://cdn.shopify.com/s/files/1/0871/6002/9508/files/printora-colour-fallbacks-10-sep-2026.webp?v=1789049007',
      cols: 12,
      rows: 11
    },
    at01j: {
      url: 'https://cdn.shopify.com/s/files/1/0871/6002/9508/files/printora-at01j-colour-fallbacks-11-sep-2026.webp?v=1789115836',
      cols: 4,
      rows: 2
    }
  };

  const ADULT = new Set(['at002', 'at003', 'rx301', 'rx350']);
  const KIDS = new Set(['at01j', 'jh01j', 'jh30j']);

  const clean = (value) => String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  function supportedGarments(card) {
    return String(card?.dataset?.pv2FallbackGarments || '')
      .split('|')
      .map(clean)
      .filter((value) => Boolean(INDEX[value]));
  }

  function supports(card, garment) {
    return Boolean(garment && INDEX[garment] && supportedGarments(card).includes(garment));
  }

  function knownSkuGarment(card) {
    const hint = clean(card?.dataset?.pv2FallbackGarment || '');
    return INDEX[hint] ? hint : '';
  }

  function activeChoice(details) {
    return details?.querySelector(
      '.pv2-garment-choice.is-active, [data-v27-garment-selector] .is-active, [data-pv2-audience-selector] .is-active'
    ) || null;
  }

  function audienceFor(root, details, choice) {
    const raw = clean(
      choice?.dataset?.pv2Audience
      || details?.querySelector('.pv2-size-fieldset')?.dataset?.pv2ActiveAudience
      || details?.querySelector('.productView-options')?.dataset?.pv2ActiveAudience
      || root?.dataset?.pv2ActiveAudience
      || ''
    );
    if (/kid|child|youth|junior/.test(raw)) return 'kids';
    if (/adult/.test(raw)) return 'adults';

    const choiceRaw = clean(
      choice?.dataset?.pv2Garment
      || choice?.dataset?.v27Garment
      || choice?.dataset?.pv2Group
      || choice?.textContent
      || ''
    );
    return /kid|child|youth|junior/.test(choiceRaw) ? 'kids' : 'adults';
  }

  function activeFabricKey(details) {
    const choice = details?.querySelector('[data-v27-fabric-choice].is-active, .pv2-fabric-choice.is-active');
    return clean(
      choice?.dataset?.v27FabricKey
      || choice?.dataset?.pv2LegacyGsm
      || choice?.dataset?.v27FabricValue
      || choice?.textContent
      || ''
    );
  }

  function choiceType(choice) {
    const raw = clean(
      choice?.dataset?.pv2Garment
      || choice?.dataset?.v27Garment
      || choice?.dataset?.pv2Group
      || choice?.textContent
      || ''
    );
    if (/hood/.test(raw)) return 'hoodies';
    if (/jump|sweat/.test(raw)) return 'jumpers';
    if (/tshirt|t-shirt|tee/.test(raw)) return 'tshirts';
    return '';
  }

  function garmentAudience(garment) {
    if (KIDS.has(garment)) return 'kids';
    if (ADULT.has(garment)) return 'adults';
    return '';
  }

  function garmentType(garment) {
    if (garment === 'rx350' || garment === 'jh01j') return 'hoodies';
    if (garment === 'rx301' || garment === 'jh30j') return 'jumpers';
    if (garment === 'at002' || garment === 'at003' || garment === 'at01j') return 'tshirts';
    return '';
  }

  function teeForFabric(supported, audience, fabricKey, hint) {
    if (audience === 'kids') return supported.includes('at01j') ? 'at01j' : '';
    if (/240/.test(fabricKey) && supported.includes('at003')) return 'at003';
    if (/180/.test(fabricKey) && supported.includes('at002')) return 'at002';
    if ((hint === 'at002' || hint === 'at003') && supported.includes(hint)) return hint;
    if (supported.includes('at003') && !supported.includes('at002')) return 'at003';
    if (supported.includes('at002') && !supported.includes('at003')) return 'at002';
    return supported.includes('at002') ? 'at002' : (supported.includes('at003') ? 'at003' : '');
  }

  function candidateForType(supported, audience, type, fabricKey, hint) {
    if (type === 'hoodies') {
      const candidate = audience === 'kids' ? 'jh01j' : 'rx350';
      return supported.includes(candidate) ? candidate : '';
    }
    if (type === 'jumpers') {
      const candidate = audience === 'kids' ? 'jh30j' : 'rx301';
      return supported.includes(candidate) ? candidate : '';
    }
    if (type === 'tshirts') return teeForFabric(supported, audience, fabricKey, hint);
    return '';
  }

  function desiredGarment(root, card) {
    const supported = supportedGarments(card);
    if (!supported.length) return '';

    const explicitGarment = root?.querySelector?.('input[name="Garment"]:checked')?.value;
    if (explicitGarment) {
      const size = root.querySelector('[data-v27-size-fieldset] input:checked')?.value || '';
      const kids = /years?|yrs?|kids/i.test(size);
      const code = /hoodie/i.test(explicitGarment) ? (kids ? 'jh01j' : 'rx350') : (kids ? 'at01j' : 'at002');
      if (supported.includes(code)) return code;
    }
    const PC = window.PrintoraCommerce || {};
    const details = PC.getDetails?.(root)
      || root?.closest?.('.productView-details, .productView, [data-product-detail]')
      || document.querySelector('.productView-details, .productView, [data-product-detail]');
    const choice = activeChoice(details);
    const audience = audienceFor(root, details, choice);
    const type = choiceType(choice);
    const fabricKey = activeFabricKey(details);
    const hint = knownSkuGarment(card);

    /*
      First respect a real garment choice, but only if the requested family actually exists
      on this colour. V27's Adults/Kids style selector historically carries tshirts-adults /
      tshirts-kids even on jumper products, so an unsupported "tee" request must not force
      a T-shirt silhouette onto an RX301/JH30J product.
    */
    const explicit = candidateForType(supported, audience, type, fabricKey, hint);
    if (explicit) return explicit;

    const sameAudience = supported.filter((garment) => garmentAudience(garment) === audience);

    if (hint && supported.includes(hint) && garmentAudience(hint) === audience) {
      if (!type || garmentType(hint) === type || sameAudience.length !== 1) return hint;
    }

    if (sameAudience.length === 1) return sameAudience[0];

    if (type) {
      const sameType = sameAudience.filter((garment) => garmentType(garment) === type);
      if (sameType.length === 1) return sameType[0];
      if (type === 'tshirts' && sameType.length > 1) {
        const tee = teeForFabric(sameType, audience, fabricKey, hint);
        if (tee) return tee;
      }
    }

    if (hint && supported.includes(hint)) return hint;
    return supported.length === 1 ? supported[0] : '';
  }

  function colourCandidates(garment, raw) {
    const key = clean(raw);
    const candidates = [key];
    const add = (...items) => items.forEach((item) => {
      if (item && !candidates.includes(item)) candidates.push(item);
    });

    if (key === 'black') {
      if (garment === 'at002' || garment === 'at003' || garment === 'at01j') add('deep-black');
      else if (garment === 'jh01j' || garment === 'jh30j') add('deep-black', 'jet-black', 'black-smoke');
      else add('black');
    }
    if (['deep-black', 'jet-black', 'black-smoke'].includes(key) && (garment === 'rx301' || garment === 'rx350')) add('black');
    if (key === 'white') add('arctic-white');
    if (key === 'arctic-white' && (garment === 'rx301' || garment === 'rx350')) add('white');
    if (key === 'orange') add('orange-crush');
    if (key === 'yellow') add('sun-yellow');
    if (key === 'red') add(garment === 'rx301' || garment === 'rx350' ? 'red' : 'fire-red');
    if (key === 'fire-red' && (garment === 'rx301' || garment === 'rx350')) add('red');
    if (key === 'orange-crush' && (garment === 'rx301' || garment === 'rx350')) add('orange');
    if (key === 'new-french-navy' && (garment === 'rx301' || garment === 'rx350')) add('navy');
    if (key === 'oxford-navy' && (garment === 'rx301' || garment === 'rx350')) add('navy');
    if (key === 'navy' || key === 'french-navy') add('new-french-navy', 'navy', 'oxford-navy');
    if (key === 'solid-charcoal') add('charcoal');
    if (key === 'charcoal') add('solid-charcoal', 'charcoal');
    if (key === 'grey' || key === 'gray' || key === 'heather') add('heather-grey', 'solid-grey', 'platinum-grey', 'storm-grey');
    if (key === 'royal') add('royal-blue', 'bright-royal');
    if (key === 'bright-royal') add('royal-blue');
    if (key === 'royal-blue' && (garment === 'jh01j' || garment === 'jh30j')) add('bright-royal');
    if (key === 'natural' || key === 'nude') add('natural-stone', 'stone', 'desert-sand');
    if (key === 'natural-stone') add('stone');
    if (key === 'stone') add('natural-stone');

    return candidates;
  }

  function spriteForGarment(garment) {
    return garment === 'at01j' ? SPRITES.at01j : SPRITES.main;
  }

  function spritePosition(garment, raw) {
    const group = INDEX[garment];
    if (!group) return null;
    for (const key of colourCandidates(garment, raw)) {
      if (group[key]) return { ...group[key], sprite: spriteForGarment(garment) };
    }
    return null;
  }

  function syncCard(root, card) {
    const fallback = card.querySelector('[data-pv2-blank-fallback]');
    const swatch = card.querySelector('[data-pv2-generic-swatch]');
    if (!fallback) return; // product-specific image already won server-side

    const garment = desiredGarment(root, card);
    const found = spritePosition(garment, card.dataset.pv2Colour || card.dataset.v27Colour || '');

    if (garment && found?.sprite?.url) {
      const { col, row, sprite } = found;
      const x = sprite.cols > 1 ? (col / (sprite.cols - 1)) * 100 : 0;
      const y = sprite.rows > 1 ? (row / (sprite.rows - 1)) * 100 : 0;
      fallback.style.display = 'block';
      fallback.style.width = '100%';
      fallback.style.aspectRatio = '1 / 1';
      fallback.style.backgroundColor = '#fff';
      fallback.style.backgroundImage = `url("${sprite.url}")`;
      fallback.style.backgroundRepeat = 'no-repeat';
      fallback.style.backgroundSize = `${sprite.cols * 100}% ${sprite.rows * 100}%`;
      fallback.style.backgroundPosition = `${x}% ${y}%`;
      fallback.hidden = false;
      fallback.dataset.pv2Garment = garment;
      if (swatch) swatch.hidden = true;
      card.classList.add('has-image', 'has-blank-fallback');
      card.classList.remove('is-swatch');
      return;
    }

    fallback.hidden = true;
    fallback.style.removeProperty('display');
    fallback.style.removeProperty('background-image');
    delete fallback.dataset.pv2Garment;
    if (swatch) swatch.hidden = false;
    card.classList.remove('has-image', 'has-blank-fallback');
    card.classList.add('is-swatch');
  }

  function syncRoot(root) {
    if (!root) return;
    root.querySelectorAll('[data-pv2-colour][data-pv2-fallback-garments]').forEach((card) => syncCard(root, card));
  }

  function roots() {
    const found = [...document.querySelectorAll('[data-printora-v2]')];
    return found.length ? found : [...document.querySelectorAll('.productView')];
  }

  function syncAll() { roots().forEach(syncRoot); }
  window.PrintoraColourFallbacks = { ready: true, version: VERSION, syncAll, syncRoot };

  const schedule = (scope) => window.requestAnimationFrame(() => {
    if (scope?.matches?.('[data-printora-v2], .productView')) syncRoot(scope);
    else syncAll();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(), { once: true });
  else schedule();
  window.addEventListener('load', () => schedule(), { once: true });

  ['pv2:garmentchange', 'pv2:audiencechange', 'pv2:coloursfiltered', 'variant:change'].forEach((name) => {
    document.addEventListener(name, (event) => {
      const root = event.target?.closest?.('[data-printora-v2], .productView');
      schedule(root);
      window.setTimeout(() => root ? syncRoot(root) : syncAll(), 80);
    });
  });

  document.addEventListener('change', (event) => {
    const root = event.target?.closest?.('[data-printora-v2], .productView');
    if (root && !event.target.closest?.('[data-v27-size-fieldset]') && event.target.name !== 'id') schedule(root);
  });
  document.addEventListener('click', (event) => {
    if (!event.target?.closest?.('.pv2-garment-choice, .pv2-fabric-choice, [data-v27-fabric-choice]')) return;
    const root = event.target.closest('[data-printora-v2], .productView');
    window.setTimeout(() => root ? syncRoot(root) : syncAll(), 0);
    window.setTimeout(() => root ? syncRoot(root) : syncAll(), 120);
    window.setTimeout(() => root ? syncRoot(root) : syncAll(), 300);
  }, true);
  document.addEventListener('shopify:section:load', (event) => schedule(event.target));

  [100, 350, 900].forEach((delay) => window.setTimeout(syncAll, delay));
})();
